import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function WhatYouGet() {
  return <Section data-id="element-192">
      <FadeIn data-id="element-193">
        <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-194">Qué incluye</h2>
        <div className="bg-white p-8 rounded-2xl border border-warm-border shadow-sm mb-16" data-id="element-195">
          <ul className="space-y-4" data-id="element-196">
            {['Ebook completo (paso a paso, 30 días)', 'Plantilla Google Sheets simple (4 bolsillos + vencimientos + deudas)', 'Versión imprimible (si lo digital te abruma)', 'Lista Anti-Fugas (recorte sin rebote)', 'Guiones para renegociar (sin humillarte)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-197">
                <div className="mt-1 p-1 bg-accent-teal/10 rounded text-accent-teal" data-id="element-198">
                  <Check className="w-4 h-4" data-id="element-199" />
                </div>
                <span className="text-lg text-text-secondary" data-id="element-200">{item}</span>
              </li>)}
          </ul>
        </div>
      </FadeIn>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-201">
        <FadeIn delay={0.2} data-id="element-202">
          <div className="bg-green-50/50 p-6 rounded-xl border border-green-100 h-full" data-id="element-203">
            <h3 className="text-xl font-bold mb-4 text-green-800" data-id="element-204">
              Es para vos si:
            </h3>
            <ul className="space-y-3" data-id="element-205">
              {['Cobrás irregular (monotributo, servicios, changas, freelance)', 'Te cansaste de vivir apagando incendios', 'Querés orden simple, sin Excel difícil', 'Querés dejar de discutir con vos mismo cada vez que mirás el saldo'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-206">
                  <Check className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-207" />
                  <span className="text-text-secondary text-sm md:text-base" data-id="element-208">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-209">
          <div className="bg-warm-section p-6 rounded-xl border border-warm-border h-full" data-id="element-210">
            <h3 className="text-xl font-bold mb-4 text-text-secondary" data-id="element-211">
              No es para vos si:
            </h3>
            <ul className="space-y-3" data-id="element-212">
              {['Buscás “hacerte rico” o inversiones agresivas', 'Querés que alguien te resuelva la vida sin mirar tus números', 'Querés “trucos” para zafar de todo'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-213">
                  <X className="w-5 h-5 text-text-secondary shrink-0 mt-0.5" data-id="element-214" />
                  <span className="text-text-secondary text-sm md:text-base" data-id="element-215">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </Section>;
}